import script from "./BookCardThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCardThumbnail.vue?vue&type=script&setup=true&lang=ts"

import "./BookCardThumbnail.vue?vue&type=style&index=0&id=f68e86f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f68e86f8"]])

export default __exports__